<template>
  <div>
    <v-sheet v-if="submitState.success" class="d-flex justify-center overflow-auto" :height="height">
      <v-sheet class="align-self-center text-center" max-width="400">
        <v-icon size="48" color="success">mdi-check-circle</v-icon>
        <div class="title">Рассылка создана</div>
        <div class="body-2 mb-4">Статус отправки рассылок можно<br/>отслеживать в разделе "История"</div>
        <v-btn depressed @click="submitState.stateInit()" class="mr-2">Назад</v-btn>
        <v-btn depressed @click="init()">Новая рассылка</v-btn>
      </v-sheet>
    </v-sheet>
    <stepper
        v-else
        :stepIndex.sync="stepIndex"
        :steps.sync="steps"
        :height="height"
    >
      <template v-slot:default="{index:k, width:w, height:h}">
        <distribute-source-form
            v-if="stepIndex===0"
            :height="h"
            :data="steps[k]" @update="(v)=>steps[k]=v"
        />
        <distribute-visits-form
            v-if="stepIndex===1 && steps[0].data==='visit'"
            :height="h" :width="w"
            :data="steps[k]" @update="(v)=>steps[k]=v"
        />
        <distribute-message-form
            v-if="stepIndex===2"
            :height="h"
            :data="steps[k]" @update="(v)=>steps[k]=v"
            :sourceType="steps[0].data"
            :sourceIds="steps[1].data.selects.map(v=>v.id)"
        />
        <distribute-settings-form
            v-if="stepIndex===3"
            :height="h"
            :data="steps[k]" @update="(v)=>steps[k]=v"
        />
      </template>
      <template v-slot:completeButton>
        <btn-accept
            name="Создать рассылку" text="Вы уверены что хотите создать рассылку?"
            :loading="submitState.loading" color="primary"
            @accept="submit()"
        >Создать рассылку</btn-accept>
      </template>
    </stepper>
  </div>
</template>

<script>
import DistributeSourceForm from "@/views/ContactCenter/Messenger/Distribute/Form/DistributeSourceForm.vue";
import Stepper from "@/componentsV2/custom/Stepper.vue";
import DistributeVisitsForm from "@/views/ContactCenter/Messenger/Distribute/Form/DistributeVisitsForm.vue";
import DistributeMessageForm from "@/views/ContactCenter/Messenger/Distribute/Form/DistributeMessageForm.vue";
import DistributeSettingsForm from "@/views/ContactCenter/Messenger/Distribute/Form/DistributeSettingsForm.vue";
import moment from "moment/moment";
import Stater from "@/plugins/stater";
import BtnAccept from "@/componentsV2/base/BtnAccept.vue";
import Api from "@/Api";
import axios from "axios";

export default {
  components: {
    BtnAccept,
    DistributeSettingsForm, DistributeMessageForm, DistributeVisitsForm, Stepper, DistributeSourceForm},
  props: ['height'],
  data: () => ({
    stepIndex:0,
    steps: [],
    submitState: new Stater()
  }),
  mounted() {
    this.init();
  },
  watch:{
    stepIndex(){
      if(this.steps[0].data!==null){
        if(this.steps[0].data==='visit' && !this.steps[1].name.includes('(визиты)'))
          this.steps[1].name += ' (визиты)';
      } else {
        this.steps[1].name = 'Фильтрация';
      }
      if(this.stepIndex===3) {
        this.steps[3].data.sendDate = moment().format('DD.MM.YYYY');
        this.steps[3].data.sendTime = moment().format('HH:mm');
        this.steps[3].data.delay = 15;
      }
    }
  },
  methods: {
    init(){
      this.stepIndex = 0;
      this.steps = [
        {name: 'Исходные данные', data: null},
        {name: 'Фильтрация', data: {filter: {userspecsExclude:false}, selects: []}},
        {name: 'Сообщение', data: {text: null, templateId: null, textTags: null}},
        {name: 'Настройка рассылки', data: {name: null, sendDate: null, sendTime: null, delay: null, comContact: null}},
      ];
      this.submitState.stateInit();
    },
    submit(){
      if(this.$tools.isEmpty(this.steps[3].data.name)){
        this.$store.commit('alertWarning', 'Название рассылки не указано');
        return;
      }
      if(this.$tools.isEmpty(this.steps[3].data.sendDate)){
        this.$store.commit('alertWarning', 'Дата отправки не указана');
        return;
      }
      if(this.$tools.isEmpty(this.steps[3].data.sendTime)){
        this.$store.commit('alertWarning', 'Время отправки не указана');
        return;
      }
      if(this.$tools.isEmpty(this.steps[3].data.delay)){
        this.$store.commit('alertWarning', 'Задержка между сообщениями не указана');
        return;
      }
      if(this.$tools.isEmpty(this.steps[3].data.comContact)){
        this.$store.commit('alertWarning', 'Не указан способ отправки');
        return;
      }

      this.submitState.stateLoading()
      axios.post(Api.host + '/messenger/distribute/', {
        name: this.steps[3].data.name,
        delay: this.steps[3].data.delay,
        sendDate: moment(this.steps[3].data.sendDate+' '+this.steps[3].data.sendTime, 'DD.MM.YYYY HH:mm').format('YYYY-MM-DD HH:mm:')+'00',
        comContactId: this.steps[3].data.comContact.id,

        sourceType: this.steps[0].data,
        sourceIds: this.steps[1].data.selects.map(v=>v.id),

        text: this.steps[2].data.text,
        textTags: this.steps[2].data.textTags,
        templateId: this.steps[2].data.templateId,
      }).then(() => {
        this.submitState.stateSuccess();
      }).catch(() => {
        this.submitState.stateError()
      });
    }
  }
}
</script>